let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ccvnQ")).then(() => parcelRequire('c9O6m'));